import { ScrollableContent } from '../../../SetupFlow/SetupFlowModal/SetupFlowModal.styled'
import { DesktopNewBadge } from '../DesktopNewBadge/DesktopNewBadge'
import { MobileAndTabletNewBadge } from '../MobileAndTabletNewBadge/MobileAndTabletNewBadge'

type ScrollableContentWithNewBadgeProps = {
  text?: string
  children: React.ReactNode
}

export const ScrollableContentWithNewBadge = ({
  text,
  children,
}: ScrollableContentWithNewBadgeProps) => {
  return (
    <>
      <MobileAndTabletNewBadge text={text} />
      <ScrollableContent
        data-testid="setup-flow-tap-to-app-stage"
        mt={{ _: '-24px', MD: '-20px', LG: '0' }}
      >
        <DesktopNewBadge text={text} />
        {children}
      </ScrollableContent>
    </>
  )
}
